import React, { useEffect, useRef, useState } from 'react';
import NotePageHeader from './NotePageHeader';
import { useNavigate, useParams } from 'react-router-dom';
import apiClient from '../services/apiClient';
import NoteEditor from './NoteEditor';
import Spinner from './Spinner';
import { t } from '../i18n';
import { editorText } from './noteEditorText';

export function useNoteEditorData(noteId) {
  const [state, setState] = useState({ note: null, loading: Boolean(noteId), error: '' });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!noteId) { setState({ note: null, loading: false, error: '' }); return undefined; }
    let cancelled = false;
    setState({ note: null, loading: true, error: '' });
    Promise.all([apiClient.getNoteMetadata(noteId), apiClient.getAllFlashCards({ noteId })]).then(([metadata, allCards]) => {
      if (!cancelled) setState({
        note: { ...metadata, noteId, cards: (allCards || []).filter((card) => String(card.noteId) === String(noteId)) },
        loading: false, error: '',
      });
    }).catch((error) => {
      if (!cancelled) setState({ note: null, loading: false, error: error.message || editorText('loadFailed') });
    });
    return () => { cancelled = true; };
  }, [noteId, attempt]);
  return { ...state, reload: () => setAttempt((value) => value + 1) };
}

function NoteEditPage({ onRefresh }) {
  const { noteId } = useParams();
  const navigate = useNavigate();
  const { note, loading, error, reload } = useNoteEditorData(noteId);
  const editorRef = useRef(null);
  const back = () => navigate('/map', { state: { noteId } });
  return <div className="note-composer-page">
    <NotePageHeader title={editorText('edit')} description={editorText('editHelp')}
      onBack={() => editorRef.current ? editorRef.current.requestCancel() : back()} />
    {loading ? <Spinner size="medium" message={t('noteComposer.page.loading')} /> : error ? <div role="alert" className="composer-page-error"><p>{editorText('loadFailed')} {error}</p><button type="button" onClick={reload}>{editorText('retry')}</button></div> :
      <NoteEditor ref={editorRef} key={noteId} initialNote={note} mode="edit" onCancel={back} onSaved={back} onSave={async (payload) => {
        await apiClient.updateNoteContent(noteId, payload);
        try { await onRefresh?.(); } catch { /* Save has already committed. */ }
      }} />}
  </div>;
}

export default NoteEditPage;
